import type { CustomTranscriberRequestDto } from '@shared/services/apiService/apiService';

export type CustomTranscriberFields = {
  provider: string;
  providerDisplayName: string;
  model: string;
  language: string;
  parameters: string;
};

export const parseParameters = (
  value: string,
): { valid: true; parameters: Record<string, unknown> } | { valid: false } => {
  if (!value.trim()) return { valid: true, parameters: {} };
  try {
    const parsed: unknown = JSON.parse(value);
    if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return { valid: false };
    }
    return { valid: true, parameters: parsed as Record<string, unknown> };
  } catch {
    return { valid: false };
  }
};

export const buildCustomTranscriberPayload = (
  fields: CustomTranscriberFields,
  parameters: Record<string, unknown>,
): CustomTranscriberRequestDto => ({
  provider: fields.provider.trim(),
  providerDisplayName: fields.providerDisplayName.trim() || null,
  model: fields.model.trim() || null,
  language: fields.language.trim() || null,
  parameters: Object.keys(parameters).length ? parameters : null,
});
